import { buildTestId } from '~/utils/buildTestId';

export const CUSTOMER_ADMIN_USERS_TABS = {
  byIDN: 0,
  byDepartment: 1,
  all: 2,
} as const;

const CUSTOMER_ADMIN_USERS_TABS_LABEL: Record<
  (typeof CUSTOMER_ADMIN_USERS_TABS)[keyof typeof CUSTOMER_ADMIN_USERS_TABS],
  string
> = {
  [CUSTOMER_ADMIN_USERS_TABS.byIDN]: 'By IDN',
  [CUSTOMER_ADMIN_USERS_TABS.byDepartment]: 'By Department',
  [CUSTOMER_ADMIN_USERS_TABS.all]: 'Search All Users',
} as const;

type CustomerAdminUsersTabsKey = keyof typeof CUSTOMER_ADMIN_USERS_TABS;
export type CustomerAdminUsersTabsValue =
  (typeof CUSTOMER_ADMIN_USERS_TABS)[keyof typeof CUSTOMER_ADMIN_USERS_TABS];

export const CustomerAdminUsersTabsConfig = (testID: string) =>
  (Object.keys(CUSTOMER_ADMIN_USERS_TABS) as CustomerAdminUsersTabsKey[]).map(
    (key) => {
      const label =
        CUSTOMER_ADMIN_USERS_TABS_LABEL[CUSTOMER_ADMIN_USERS_TABS[key]];

      return {
        label,
        'aria-label': label,
        testID: buildTestId({ testID, suffix: ['tab', label] }),
      };
    },
  );
